// FILE: src/pages/AdminAuditLogPage.jsx
// Audit log (plan WP-8 / WP-7; MTO 11.1, matrix 5.1 / 5.8, B-9): what
// happened, to which account and when, with the outcome. Actions are in
// words (auditActionLabel) and details are readable "label: value" pairs,
// never JSON. The server filters (account email, kind of event or one
// action, outcome, Toronto dates) and pages; both are kept in the URL.
import React from "react";
import { Box } from "@mui/material";
import { PageHeader } from "../components/ui";
import AuditLogBrowser from "../components/admin/AuditLogBrowser";

export default function AdminAuditLogPage() {
  return (
    <Box>
      <PageHeader
        title="Audit log"
        description="Every sign-in, account change, course event and records download the system records, newest first. Entries can't be changed or removed."
      />
      <AuditLogBrowser showEmail showAccount />
    </Box>
  );
}
